export default [
    {
        title: '数仓',
        path: '/hadoop',
        name: 'hadoop',
        meta: {
            key: 'hadoop'
        },
        permission: false,
        permissionCheck: () => {
            return true;
        },
        menu: true,
        children: [
            {
                title: '品牌查看',
                path: '/hadoop/brand',
                name: 'hadoopBrand',
                component: () => import('@/views/hadoop/brand/index'),
                meta: {
                    key: 'hadoopBrand',
                    open: 'hadoop'
                },
                permission: false,
                permissionCheck: () => {
                    return true;
                },
                menu: true
            },
            {
                title: '类目查看',
                path: '/hadoop/category',
                name: 'hadoopCategory',
                component: () => import('@/views/hadoop/category/index'),
                meta: {
                    key: 'hadoopCategory',
                    open: 'hadoop'
                },
                permission: false,
                permissionCheck: () => {
                    return true;
                },
                menu: true
            },
            {
                title: 'SPU查看',
                path: '/hadoop/spu',
                name: 'hadoopSpu',
                component: () => import('@/views/hadoop/spu/index'),
                meta: {
                    key: 'hadoopSpu',
                    open: 'hadoop'
                },
                permission: false,
                permissionCheck: () => {
                    return true;
                },
                menu: true
            },
            {
                title: 'Sku查看',
                path: '/hadoop/sku',
                name: 'hadoopSku',
                component: () => import('@/views/hadoop/sku/index'),
                meta: {
                    key: 'hadoopSku',
                    open: 'hadoop'
                },
                permission: false,
                permissionCheck: () => {
                    return true;
                },
                menu: true
            }
        ]
    }
];